import callApi from '../../util/apiCaller';
import { getPriceCent, getPriceFromCent, formatPrice } from '../../util/price';

import { getPriceTypes, getPriceValue } from '../Institution/CreditActions';
import { setIsFetching, FETCH_LIMIT, getItemsRequest } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_INVOICES = 'SET_INVOICES';
export const SET_INVOICE = 'SET_INVOICE';
export const REMOVE_INVOICE = 'REMOVE_INVOICE';

export const INVOICE_STATUS_PENDING = 'pending';
export const INVOICE_STATUS_REFUSED = 'refused';
export const INVOICE_STATUS_ACCEPTED = 'accepted';
export const INVOICE_STATUS_PENDINGPAYMENT = 'pendingpayment';
export const INVOICE_STATUS_PAYED = 'payed';

export function getInvoicesRequest(search = '', filters = null, sorter = null, pager = null, options = {}) {
    return dispatch => dispatch(getItemsRequest('invoices', null, items => dispatch(setInvoices(items, false)), { search, filters, sorter, pager }, options));
}

export function getInvoicesCountRequest(search = '', filters = {}) {
    return dispatch => {
        return callApi(`invoices/count?${search ? `search=${search}&` : ''}${filters ? `${Object.keys(filters).map(filterKey => `filters[${filterKey}]=${filters[filterKey]}`).join('&')}&` : ''}`).then(result => {
            return result.count;
        }).catch(err => {
            return null;
        });
    };
}

export function getInvoiceRequest(invoiceId) {
    return dispatch => {
        return callApi(`invoice/${invoiceId}`).then(result => {
            result.invoice && dispatch(setInvoice(result.invoice));
            return result.invoice;
        }).catch(err => {
            return null;
        });
    };
}

export function editInvoiceRequest(invoice) {
    return dispatch => {
        return callApi('invoice/edit', 'post', { invoice }).then(result => {
            result.invoice && dispatch(getInvoiceRequest(result.invoice._id));
            return result.invoice;
        }).catch(err => {
            return null;
        });
    };
}

export function sendValidQuoteRequest(invoice, user, mode = 'email') {
    return dispatch => {
        return callApi('invoice/valid/quote/send', 'post', { invoice: { _id: invoice._id }, user: { _id: user._id }, mode }).then(result => {
            result.invoice && dispatch(getInvoiceRequest(result.invoice._id));
            return result.invoice;
        }).catch(err => {
            return null;
        });
    };
}

export function validQuoteRequest(invoice, newStatus, code = '') {
    return dispatch => {
        return callApi('invoice/valid/quote', 'post', { invoice: { _id: invoice._id }, status: newStatus, code }).then(result => {
            result.ok && dispatch(getInvoiceRequest(invoice._id));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function sendInvoiceToRecipientsRequest(invoiceId) {
    return dispatch => {
        return callApi(`invoice/send/${invoiceId}`).then(result => {
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function removeInvoiceRequest(invoiceId) {
    return dispatch => {
        return callApi('invoice/remove', 'delete', { invoice: { _id: invoiceId } }).then(result => {
            result.ok && dispatch(removeInvoice(invoiceId));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getInvoices(store, type = null) {
    const invoices = store.invoices.data;
    if(type) {
        return invoices.filter(invoice => invoice.type === type);
    }
    return invoices;
}

export function getInvoice(store, id) {
    return store.invoices.data.find(invoice => invoice._id === id);
}

export function canEditInvoice(invoice, user) {
    return ['root'].includes(user.role);
}

export function canRemoveInvoice(invoice, user) {
    return ['root'].includes(user.role) && (
        (invoice.type === 'quote' && invoice.status === INVOICE_STATUS_PENDING)
        || (invoice.type === 'invoice' && invoice.status === INVOICE_STATUS_PENDINGPAYMENT)
    );
}

export function getInvoiceStatuses(type = null) {
    if(type === 'invoice') {
        return [INVOICE_STATUS_PENDINGPAYMENT, INVOICE_STATUS_PAYED];
    }
    if(type === 'quote') {
        return [INVOICE_STATUS_PENDING, INVOICE_STATUS_REFUSED, INVOICE_STATUS_ACCEPTED];
    }
    return [INVOICE_STATUS_PENDING, INVOICE_STATUS_REFUSED, INVOICE_STATUS_ACCEPTED, INVOICE_STATUS_PENDINGPAYMENT, INVOICE_STATUS_PAYED];
}

export function getInvoiceEntryTypes() {
    return getPriceTypes().filter(type => type !== 'taxRate');
}

export function getInvoiceEntryTotal(entry) {
    return getPriceFromCent(getPriceCent(parseFloat(`${entry.unitPrice || 0}`.replace(',', '.'))) * parseFloat(`${entry.quantity || 0}`.replace(',', '.')));
}

export function getTotalExclTax(invoice) {
    return invoice
        ? formatPrice((invoice.entries || []).reduce((total, entry) => total + getInvoiceEntryTotal(entry), 0))
        : 0;
}

export function getTotalInclTax(invoice) {
    return getPriceFromCent(getPriceCent(getTotalExclTax(invoice)) * (1 + parseFloat(`${getPriceValue(invoice, 'taxRate')}`.replace(',', '.'))));
}

export function getTax(invoice) {
    return getPriceFromCent(getPriceCent(getTotalExclTax(invoice) || 0) * (parseFloat(`${getPriceValue(invoice, 'taxRate')}`.replace(',', '.')) || 0));
}

export function getInvoiceColor(status) {
    switch(status) {
        case 'pending':
            return 'primary';

        case 'refused':
            return 'danger';

        case 'accepted':
            return 'info';

        case 'pendingpayment':
            return 'warning';

        case 'payed':
            return 'success';

        default:
            return 'secondary';
    }
}

export function getTransmitters() {
    return ['managexam', 'cff'];
}

// Export Actions
export function setInvoices(invoices, invoiceType = null) {
    return {
        type: SET_INVOICES,
        invoices,
        invoiceType,
    };
}

export function setInvoice(invoice) {
    return {
        type: SET_INVOICE,
        invoice,
    };
}

export function removeInvoice(invoiceId) {
    return {
        type: REMOVE_INVOICE,
        invoiceId,
    };
}
